module.exports = __webpack_public_path__ + "img/du.211717bc.png";